module.exports = __webpack_public_path__ + "img/rank3.ce1586e7.svg";